module.exports = __webpack_public_path__ + "images/emoji/moon.42c7f5dbe39b95fbd73b.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/moon.png
// module id = ewXk
// module chunks = 14